import script from "./PromptSidebar.vue?vue&type=script&setup=true&lang=js"
export * from "./PromptSidebar.vue?vue&type=script&setup=true&lang=js"

import "./PromptSidebar.vue?vue&type=style&index=0&id=95ebce68&lang=css"

const __exports__ = script;

export default __exports__